/**
 * Enum might have values as numbers or strings
 * Returned values are always arrays of strings
 */
export function getEnumValues(e: object): string[] {
    const keys: string[] = Object.keys(e);
    return keys.map(
        (key: string): string => {
            return e[key].toString();
        }
    );
}
